import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const COUNTER_ID = 105410657;

const YandexMetrika = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== "undefined" && typeof window.ym === "function") {
      window.ym(COUNTER_ID, "hit", location.pathname + location.search);
    }
  }, [location.pathname, location.search]);

  return null;
};

export default YandexMetrika;